module.exports = __webpack_public_path__ + "static/media/TitleImage.9dc65054.jpeg";